import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";

export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });
  };

  return (
    <footer className="site-footer" dir="rtl">

      {/* אזור הניווט הראשי */}
      <div className="footer-container">

        {/* עמודה 1: ניווט מהיר */}
        <div className="footer-column">
          <h3 className="footer-title">ניווט מהיר</h3>

          <ul className="footer-inline-list">
            <li>
              <Link to="/" onClick={scrollToTop}>
                עמוד הבית
              </Link>
            </li>

            <li>
              <Link to="/ServicesPage" onClick={scrollToTop}>
                השירותים שלנו
              </Link>
            </li>

            <li>
              <Link to="/about" onClick={scrollToTop}>
                אודות
              </Link>
            </li>

            <li>
              <Link
                to="/Moving_with_a_lifting_crane"
                onClick={scrollToTop}
              >
                הובלה עם מנוף הרמה
              </Link>
            </li>

            <li>
              <Link to="/WorksGallery" onClick={scrollToTop}>
                גלריית עבודות
              </Link>
            </li>

            <li>
              <Link to="/ContactSection2" onClick={scrollToTop}>
                צור קשר
              </Link>
            </li>

            <li>
              <Link to="/Privacy_Policy" onClick={scrollToTop}>
                מדיניות פרטיות
              </Link>
            </li>
          </ul>
        </div>


        {/* עמודה 2: השירותים שלנו */}
        <div className="footer-column">
          <h3 className="footer-title">השירותים שלנו</h3>

          <ul className="footer-inline-list">

            <li>
              <Link
                to="/Transportation_of_building_materials"
                onClick={scrollToTop}
              >
                הובלת חומרי בניין
              </Link>
            </li>

            <li>
              <Link to="/Transporting_wood" onClick={scrollToTop}>
                הובלת עצים
              </Link>
            </li>

            <li>
              <Link
                to="/Transporting_heavy_equipment"
                onClick={scrollToTop}
              >
                הובלת ציוד כבד
              </Link>
            </li>

            <li>
              <Link
                to="/Container_Transportation"
                onClick={scrollToTop}
              >
                הובלת מכולות
              </Link>
            </li>

          </ul>
        </div>


        {/* עמודה 3: שירותים נוספים */}
        <div className="footer-column">
          <h3 className="footer-title">שירותים נוספים</h3>

          <ul className="footer-inline-list">

            <li>
              <Link to="/Basket_crane_rental" onClick={scrollToTop}>
                השכרת מנוף סל
              </Link>
            </li>

            <li>
              <Link to="/Crane_Rental1" onClick={scrollToTop}>
                השכרת מנוף זרוע
              </Link>
            </li>

            <li>
              <Link
                to="/Hourly_Lifting_Basket_Rental"
                onClick={scrollToTop}
              >
                השכרת סל הרמה לפי שעה
              </Link>
            </li>

            <li>
              <Link
                to="/Renting_a_basket_crane_for_lifting_a_person"
                onClick={scrollToTop}
              >
                השכרת מנוף סל להרמת אדם
              </Link>
            </li>

            <li>
              <Link
                to="/Crane_work_throughout_the_country"
                onClick={scrollToTop}
              >
                עבודות מנוף בכל הארץ
              </Link>
            </li>

          </ul>
        </div>


        {/* עמודה 4: פרטי קשר */}
        <div className="footer-column contact-column">

          <h3 className="footer-title">פרטי קשר</h3>

          <div className="footer-contact-item">
            <strong>כתובת:</strong>
            <span>מבצע דקל 14, פתח תקווה</span>
          </div>

          <div className="footer-contact-item">
            <strong>טלפון:</strong>
            <a href="tel:0557711773">
              055-7711773
            </a>
          </div>

          <div className="footer-contact-item">
            <strong>טלפון נוסף:</strong>
            <a href="tel:0506978865">
              050-6978865
            </a>
          </div>

          <div className="footer-contact-item">
            <strong>אימייל:</strong>
            <a href="mailto:S.mtrucks55@gmail.com">
              S.mtrucks55@gmail.com
            </a>
          </div>

        </div>

      </div>


      {/* אזור זכויות יוצרים תחתון */}
      <div className="footer-bottom">

        <div className="footer-bottom-container">

          <div>
            © 2026 כל הזכויות שמורות לש.מ הובלות ומנופים
            {" "}– הובלות, מנופים ושירותי הרמה
          </div>

          <div className="footer-logo">
            <a
              href="https://siteb2b.co.il/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img
                src="/logooo.png"
                alt="Site B2B"
              />
            </a>
          </div>

        </div>

      </div>

    </footer>
  );
}
